import React from 'react'
import { useUsers } from 'state/users'
import { compact } from 'utilities/array'
import { PeopleList } from './s'
import Loader from 'components/loader'
import Person from './person'
import LoadMore from 'components/load-more'

const People = ({ fixed, prepicked, locked, picked, togglePicked, method, salt }) => {
    const {
        items: fetched,
        isLoading
    } = useUsers()

    const items = fixed ?? fetched

    return (
        <>
            {isLoading && <Loader />}
            <PeopleList>
                {items.map(person => (
                    <Person
                        person={person}
                        prepicked={prepicked}
                        locked={locked}
                        picked={picked}
                        toggle={togglePicked}
                        method={method}
                        salt={`${salt}:people`}
                        key={compact([
                            salt,
                            'person',
                            person.id,
                            prepicked.map(({ id }) => id).includes(person.id) && 'prepicked',
                            locked.map(({ id }) => id).includes(person.id) && 'locked',
                            picked.map(({ id }) => id).includes(person.id) && 'picked'
                        ]).join(':')} />
                ))}
                {!fixed && (
                    <LoadMore
                        useItems={useUsers}
                        appearance="list"
                        auto />
                )}
            </PeopleList>
        </>
    )
}

export default People